import { render, staticRenderFns } from "./IhsSystems.vue?vue&type=template&id=05a75570&scoped=true&"
import script from "./IhsSystems.vue?vue&type=script&lang=js&"
export * from "./IhsSystems.vue?vue&type=script&lang=js&"
import style0 from "./IhsSystems.vue?vue&type=style&index=0&id=05a75570&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a75570",
  null
  
)

export default component.exports